import React from 'react';
import firebase from 'firebase';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import './SignInOptions.css';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as ROUTES from '../../constants/routes';
import { useHistory, useLocation } from 'react-router';
import PhoneIcon from '@material-ui/icons/Phone';
import { useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { set } from 'lodash';

function SignUpOptions({ check, setError }) {
	const history = useHistory();
	const [show, setShow] = useState(false);
	const [formData, setFormData] = useState({
		fullname: '',
	});

	const [phoneNumber, setPhoneNumber] = useState();

	const { fullname } = formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	var uiConfig = {
		signInFlow: 'popup',
		signInOptions: [
			{
				provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
				fullLabel: 'Sign Up With Google',
			},
			{
				provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
				fullLabel: 'Sign Up With Facebook',
			},
		],
		callbacks: {
			beforeSignInSuccess: () => {
				return false;
			},
			signInSuccessWithAuthResult: (authResult) => {
				console.log('authResult ' + JSON.stringify(authResult));

				var email = authResult.user.email;
				var fullName = authResult.user.displayName;
				var telNumber = authResult.user.phoneNumber;
				console.log('phoneNumber ' + authResult.user.phoneNumber);
				var currentUserId = authResult.user.uid;
				var userPost = firebase.database().ref('/users/' + currentUserId);
				userPost.set({
					email: email,
					phoneNumber: telNumber,
					fullName: fullName,
					displayName: fullName,
					avatarCode: 'undefined',
					project_code: PROJECT_CODE.projectCode,
					userType: 'client',
				});
				return false;
			},
		},
	};

	const handleSignUp = (e) => {
		e.preventDefault();
		if (check === false) {
			setError('You have to accept the terms and conditions.');
		} else if (phoneNumber === '' || fullname === '') {
			setError('Please fill in all the fields');
		} else {
			var recaptcha = new firebase.auth.RecaptchaVerifier('recaptcha');

			firebase
				.auth()
				.signInWithPhoneNumber(phoneNumber, recaptcha)
				.then(function (e) {
					var code = prompt('Enter code send to your phone number: ', '');

					if (code === null) return;

					e.confirm(code)
						.then(function (result) {
							var currentUserId = firebase.auth().currentUser.uid;
							var userPost = firebase.database().ref('/users/' + currentUserId);
							console.log(result.user);

							userPost.set({
								displayName: fullname,
								phoneNumber: phoneNumber,
								project_code: PROJECT_CODE.projectCode,
							});
							history.push(ROUTES.HOME);
						})
						.catch(function (error) {
							console.error(error);
						});
				})
				.catch(function (error) {
					console.error(error);
					setError(error.message);
				});
		}
	};

	const useStyles = makeStyles({
		root: {
			marginLeft: '0px',
		},
	});

	const styles = useStyles();

	return (
		<div className='signinoptions'>
			<StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
			{show ? (
				<div className='phone_signup_container'>
					<form className='form formPhoneNumber' noValidate autocomplete='off'>
						<div className='form-group'>
							<TextField
								type='text'
								label='Full Name'
								name='fullname'
								value={fullname}
								onChange={(e) => onChange(e)}
								required
							/>
						</div>
						<div className='form-group'>
							<PhoneInput
								placeholder='Enter phone number'
								value={phoneNumber}
								onChange={setPhoneNumber}
								defaultCountry='CA'
							/>
						</div>
						<div className='phone_control'>
							<div className='phone_cancel_btn'>
								<button className='phonebtn' onClick={() => setShow(false)}>
									Cancel
								</button>
							</div>
							<div className='phone_register'>
								<button
									type='submit'
									className='registerbtn'
									onClick={handleSignUp}
								>
									Register
								</button>
							</div>
						</div>
						<div id='recaptcha'></div>
					</form>
				</div>
			) : (
				<div className='phone_signup_container'>
					<button className='phoneBtn' onClick={() => setShow(true)}>
						<PhoneIcon className='phoneIcon' />
						<span>Sign Up with Phone Number</span>
					</button>
				</div>
			)}
		</div>
	);
}

export default SignUpOptions;
